import { gql } from "@apollo/client";

const RunActionFieldsFragment = gql`
  fragment RunActionFieldsFragment on Run {
    id
    finished
    pluginLogs {
      message {
        message
        timestamp
      }
      pluginName
    }
    history {
      hasLogs
      note
      state
      terminal
      timestamp
      until
      username
      stateVersion
    }
    state
  }
`;

export default RunActionFieldsFragment;
